import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AuthService } from '../../services/auth.service';
import { CompanyService } from '../../services/company.service';
import { LocalService } from '../../services/local.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {
  color = 'default';
  showSettings = false;
  showMiniSidebar = false;
  showDarktheme = false;
  showRtl = false;
  companyList = [];
  myCompany = {
    logoUrl: '',
    name: ''
  };
  chatBotEnabled: boolean;
  role: number;
  isConversationsRoute: boolean = false;
  isMobile: boolean = false;

  public currentVersion: string = '1.2.5';
  public innerWidth: any;
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('appVersionModal', { static: false }) public appVersionModal: TemplateRef<any>;
  private _appVersionModalRef: NgbModalRef;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private localService: LocalService,
    public auth: AuthService,
    public companyService: CompanyService,
    private _modalService: NgbModal,
    private _translateService: TranslateService
  ) {
    this.chatBotEnabled = false;
    if (this.auth.user === "{}") { this.router.navigate(['/login']); }
  }

  ngOnInit() {
    this.role = this.auth.user.role.id;
    this.isConversationsRoute = this.router.url.includes('/admin/conversations');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isConversationsRoute = event.urlAfterRedirects.includes('/admin/conversations');
      }
    });

    if (this.router.url === '/') {
      if (this.role === 5) {
        this.router.navigate(['/admin/conversations/']);
      }
      else { this.router.navigate(['/admin/dashboard/']); }
    }
    if (this.auth.user.company) {
      let rebaseCompany = {};
      this.companyList = this.route.snapshot.data.companyList;
      const reloadCompany = this.companyList.find(data => {
        if (data.id === this.auth.user.company.id) {
          return data;
        }
      });

      rebaseCompany = this.localService.getJsonValue('userData');


      if (!reloadCompany && this.auth.user.company) {
        this.companyService.getCompany(this.auth.user.company.id).subscribe((data: any) => {
          if (data) {

            Object.assign(rebaseCompany,
              { company: data, bot: data.bots[0] });
            this.localService.setJsonValue('userData', rebaseCompany);
            sessionStorage.clear();
            this.auth.user.company = data;
            this.myCompany = data;

          }

        });
      } else {
        Object.assign(rebaseCompany, { company: reloadCompany, bot: reloadCompany.bots[0] });
        this.localService.setJsonValue('userData', rebaseCompany);
        this.myCompany = reloadCompany ? reloadCompany : this.auth.user.company;
      }

      this.handleLayout();

    } else {
      this.router.navigate(['/login']);
    }

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleLayout();
  }

  toggleSidebar() {
    this.showMiniSidebar = !this.showMiniSidebar;
  }

  handleLayout() {
    this.innerWidth = window.innerWidth;
    this.showMiniSidebar = this.innerWidth < 1170;
    this.isMobile = this.innerWidth < 768;
  }

  toggleChatBot(event: any) {
    this.chatBotEnabled = event;
  }

  openVersionModal(): void {
    this._appVersionModalRef = this._modalService.open(this.appVersionModal, { size: 'lg', centered: true });
  }
}
